import { type ChangeEvent, type FormEvent, useState } from 'react';
import { api } from '../../../api/client';
import styles from './CategoryForm.module.css';

interface ExpenseCategory {
  id: string;
  name: string;
}

interface CategoryFormProps {
  category: ExpenseCategory | null;
  onClose: () => void;
  onSuccess: () => void;
}

export default function CategoryForm({ category, onClose, onSuccess }: CategoryFormProps) {
  const isEdit = !!category;
  const [name, setName] = useState(category?.name ?? '');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      if (isEdit) {
        await api.put(`/api/expenses/categories/${category!.id}`, { name });
      } else {
        await api.post('/api/expenses/categories', { name });
      }
      onSuccess();
    } catch (err: any) {
      setError(err.message || 'Error al guardar');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.header}>
          <h2>{isEdit ? 'Editar Categoría' : 'Nueva Categoría'}</h2>
          <button onClick={onClose} className={styles.closeBtn}>
            &times;
          </button>
        </div>
        {error && <div className={styles.error}>{error}</div>}
        <form onSubmit={handleSubmit} className={styles.form}>
          <div className={styles.field}>
            <label>Nombre</label>
            <input
              value={name}
              onChange={(e: ChangeEvent<HTMLInputElement>) => setName(e.target.value)}
              required
              autoFocus
            />
          </div>
          <div className={styles.footer}>
            <button type="button" onClick={onClose} className={styles.cancelBtn}>
              Cancelar
            </button>
            <button type="submit" disabled={loading} className={styles.submitBtn}>
              {loading ? 'Guardando...' : isEdit ? 'Actualizar' : 'Crear'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
